'use client';

import React from 'react';
import { XIcon } from 'lucide-react';
import { useTheme } from 'next-themes';
import { Toaster as Sonner, toast } from 'sonner';

export type ToasterElement = React.ComponentRef<typeof Sonner>;
export type ToasterProps = React.ComponentProps<typeof Sonner>;
const Toaster = (props: ToasterProps): React.JSX.Element => {
  const { theme = 'system' } = useTheme();
  return (
    <Sonner
      theme={theme as ToasterProps['theme']}
      className="toaster group"
      // Plain X, centred on the right; `!` overrides Sonner's own styles.
      icons={{ close: <XIcon className="size-4" /> }}
      toastOptions={{
        classNames: {
          closeButton:
            'left-auto! right-3! top-1/2! -translate-y-1/2 transform-none! size-5! border-0! bg-transparent! hover:bg-transparent! opacity-70 transition-opacity hover:opacity-100'
        }
      }}
      style={
        {
          '--normal-bg': 'var(--popover)',
          '--normal-text': 'var(--popover-foreground)',
          '--normal-border': 'var(--border)'
        } as React.CSSProperties
      }
      {...props}
    />
  );
};

export { Toaster, toast };
